var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.564,
    height: 9.513,
    viewBox: "0 0 12.564 9.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2877",
    "data-name": "Group 2877",
    transform: "translate(-199.514 -434.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "right-arrow",
    d: "M-15.136,12.075a.208.208,0,0,0-.327.009.3.3,0,0,0,.008.382l1.773,1.967h-8.087A.253.253,0,0,0-22,14.7a.253.253,0,0,0,.231.27h8.08l-1.766,1.967a.3.3,0,0,0-.008.382.216.216,0,0,0,.167.084.214.214,0,0,0,.159-.075l2.017-2.246a.586.586,0,0,0,.135-.382.589.589,0,0,0-.14-.387Z",
    transform: "translate(225.061 422.07)",
    fill: "#00c2ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-arrow-2",
    "data-name": "right-arrow",
    d: "M6.864.075a.208.208,0,0,0-.327.009.3.3,0,0,0,.008.382L8.319,2.433H.231A.253.253,0,0,0,0,2.7a.253.253,0,0,0,.231.27h8.08L6.545,4.941a.3.3,0,0,0-.008.382.216.216,0,0,0,.167.084.214.214,0,0,0,.159-.075L8.881,3.086a.607.607,0,0,0,0-.769Z",
    transform: "translate(208.531 443.584) rotate(180)",
    fill: "#00c2ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRight);
export default __webpack_public_path__ + "static/media/arrow-left-right.3dae967e.svg";
export { ForwardRef as ReactComponent };